import React from "react";
import {connect} from "react-redux";

import { goTo } from "../tools";
import SeguridadForm from "./seguridad.frm";
import PasswordForm from "./password.frm";
import ModalMessage from "../registro/modalMessage";
import { actualizarDatos, actualizarPassword } from "./servicios.act";

const mapState = (state) => {
	return {
		uid: state.recuperar.uid,
		estatus: state.recuperar.estatus
	};
};

const mapDispatch = (dispatch) => {
	return {
		showLoad: () => {
			dispatch({ "type": "LOADER_SHOW"});
		},
		alerta: (sTitulo, sMensaje, fnCerrar) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": sTitulo, "mensaje": sMensaje, "accion": fnCerrar });
		},
		actualizarDatos(datos) {
			dispatch(actualizarDatos(datos));
		},
		actualizarPassword(uid,pass){
			dispatch(actualizarPassword(uid,pass));
		}
	};
};

class Seguridad extends React.Component{

	close = () => {
		goTo("login");
	}
	
	submit = (data) => {
		return new Promise(resolve => {
			if(this.props.estatus == "m"){
				this.props.showLoad();
				let telefonos = [{
					"lada": data.lada_movil.indexOf("+") != -1 ? data.lada_movil.substring(1, data.lada_movil.length) : data.lada_movil,
					"tipoTelefono": "P",
					"numero": data.telefono_movil,
					"cveTipoContacto": "TLCL"
				}];
				if(data.lada_fijo && data.telefono_fijo){
					telefonos.push({
						"lada": data.lada_fijo.indexOf("+") != -1 ? data.lada_fijo.substring(1, data.lada_fijo.length) : data.lada_fijo,
						"tipoTelefono": "A",
						"numero": data.telefono_fijo,
						"cveTipoContacto": "TLPT"
					});
				}
				let datos = {
					uid: this.props.uid,
					pass: data.password,
					p1: data.pregunta1,
					p2: data.pregunta2,
					r1: data.respuesta1,
					r2: data.respuesta2,
					tel: telefonos
				};
				this.props.actualizarDatos(datos);
				resolve();
			}
			else if(this.props.estatus == "nm"){
				this.props.showLoad();
				this.props.actualizarPassword(this.props.uid,data.password);
				resolve();
			}
			
		});
	}

	render() {
		return (
			<div>
				{ this.props.tipo == "m" &&
					<SeguridadForm onSubmit={this.submit} />
				}
				{ this.props.tipo == "nm" &&
					<PasswordForm onSubmit={this.submit} />
				}
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Seguridad);


// WEBPACK FOOTER //
// ./src/recuperar-contrasenia/seguridad.cmpt.js